export default "__VITE_ASSET__BGAclR8a__"